import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { MemberDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';

const CLASS_NAME = 'MemberDao';

@Injectable()
export class MemberDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.memberDAO, new DefaultRetryHandler(), new MemberDataValidator(), log, cookieService);
  }

  public get(): Observable<any> {
    const url = this.daoConfig.url;
    return this.doGet(url);
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/member.dao.ts